import { html, Page, View } from 'rune-ts';
import klass from './AllCreators.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { type ProductCardData } from '../../../features/ProductList/type';
import { FloatingButton_recent_product } from '../../components/cells/FloatingBox/FloatingButtons/FloatingButton_recent_product';
import { FloatingBox } from '../../components/cells/FloatingBox/FloatingBox';
import { AllCreatorsPageController } from '@services/MarppleShop/renderApp/pages/AllCreators/AllCreatorsPageController.ts';
import type {
  CreatorFilterInfo,
  CreatorSearchData,
  GetCreatorSearch,
} from '@services/MarppleShop/features/Creator/type';
import { font } from '@services/MarppleShop/shared/typography';
import { htmlIf } from '@services/MarppleShop/shared/util';

export type AllCreatorsPageData = {
  recent_product?: ProductCardData;
  layout_options: BaseLayoutOptions;
  creators: CreatorSearchData[];
  filters: CreatorFilterInfo[];
  search_count: number;
  all_count: number;
  creator_search: GetCreatorSearch;
};

class AllCreatorsBodyView extends View<AllCreatorsPageData> {
  private controller = new AllCreatorsPageController(this.data);

  protected override template() {
    return html` <div class="${klass.container}">
      <div class="${klass.title}">${this.controller.titleView}</div>

      <!--   search   -->
      <div class="${klass.search}">${this.controller.creatorSearchSectionView}</div>

      <!--   search_result   -->
      ${htmlIf(
        html`<div class="${klass.search_result} ${font('28_bold', '20_bold')}">
          <span class="${klass.blue}">${html.preventEscape(this.data.creator_search.search || '')}</span>
          ${html.preventEscape(this.controller.texts.search_result)}
        </div> `,
        !!this.data.creator_search.search,
      )}

      <!--   filter   -->
      <div class="${klass.filter_container}">${this.controller.creatorFilterButtonListView}</div>

      <!--   search_card   -->
      ${htmlIf(this.controller.creatorSearchCardListView, this.data.creators.length > 0)}

      <!--   empty screen   -->
      ${this.controller.searchEmptyScreen}

      <div class="${klass.pagination}">${this.controller.paginationView}</div>

      ${this.controller.collaborationModalView}
    </div>`;
  }

  protected override onRender() {
    this.controller.delegateProposalCollaboration(this);

    this.controller.delegateFanLetterButtonClick(this);

    this.controller.delegateCreatorFilterButtonClick(this, this.data.filters);

    this.controller.delegatePaginationChangeEvent(this);

    this.controller.delegateReplaceUrlEvent(this);
  }
}

export class AllCreatorsPage extends Page<AllCreatorsPageData> {
  protected override template(data: AllCreatorsPageData) {
    const { layout_options } = data;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: new AllCreatorsBodyView(this.data),
            footer_data: { ...footer_links, is_mobile: layout_options.is_mobile, lang: ET.lang },
          },
          {
            has_bottom_tab_bar: true,
            selected_bottom_tab_idx: 1,
            full_width: layout_options.is_mobile,
            floating_box: {
              recent_product: FloatingButton_recent_product.makeProps(this.data.recent_product),
              async renderHook(view: FloatingBox) {
                await FloatingBox.refreshRecentProductFloatingButton(view);
              },
            },
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
